import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
  selectedReport: null,
  getReportLoading: false,
  getReportError: null,
  getReportCitiesLoading: false,
  getReportCitiesError: null,
  getReportSpeakersLoading: false,
  getReportSpeakersError: null,
  cities: [],
  speakers: [],
};

export const fetchReport = createAsyncThunk(
  "report/fetchReport",
  async (
    { id, speaker_name, city, date_from, date_to },
    { rejectWithValue },
  ) => {
    try {
      const token = localStorage.getItem("OrviSlideToken");

      // ✅ Build query params dynamically
      const params = new URLSearchParams();

      if (speaker_name) params.append("speaker_name", speaker_name);
      if (city) params.append("city", city);
      if (date_from) params.append("date_from", date_from);
      if (date_to) params.append("date_to", date_to);

      const queryString = params.toString();

      const url = `${process.env.REACT_APP_API_URL}/api/admin/reports/report/${id}${
        queryString ? `?${queryString}` : ""
      }`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        return rejectWithValue(
          errorData.message
            ? errorData
            : errorData.error || "Failed to fetch Report data",
        );
      }

      const data = await response.json();
      return data.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const fetchReportCities = createAsyncThunk(
  "report/fetchReportCities",
  async (id, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("OrviSlideToken");
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/admin/reports/report/${id}/cities`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        return rejectWithValue(
          errorData.message
            ? errorData
            : errorData.error || "Failed to fetch Report cities",
        );
      }
      const data = await response.json();
      const reportData = data.data;
      return reportData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);
export const fetchReportSpeakers = createAsyncThunk(
  "report/fetchReportSpeakers",
  async (id, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("OrviSlideToken");
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/admin/reports/report/${id}/speakers`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        return rejectWithValue(
          errorData.message
            ? errorData
            : errorData.error || "Failed to fetch Report speakers",
        );
      }
      const data = await response.json();
      const reportData = data.data;
      return reportData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

const reportSlice = createSlice({
  name: "report",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      //  REPORT
      .addCase(fetchReport.pending, (state) => {
        state.getReportLoading = true;
        state.getReportError = null;
      })
      .addCase(fetchReport.fulfilled, (state, action) => {
        state.getReportLoading = false;
        state.selectedReport = action.payload;
      })
      .addCase(fetchReport.rejected, (state, action) => {
        state.getReportLoading = false;
        state.getReportError = action.payload;
      })

      //  CITIES
      .addCase(fetchReportCities.pending, (state) => {
        state.getReportCitiesLoading = true;
        state.getReportCitiesError = null;
      })
      .addCase(fetchReportCities.fulfilled, (state, action) => {
        state.getReportCitiesLoading = false;
        state.cities = action.payload;
      })
      .addCase(fetchReportCities.rejected, (state, action) => {
        state.getReportCitiesLoading = false;
        state.getReportCitiesError = action.payload;
      })

      //  SPEAKERS
      .addCase(fetchReportSpeakers.pending, (state) => {
        state.getReportSpeakersLoading = true;
        state.getReportSpeakersError = null;
      })
      .addCase(fetchReportSpeakers.fulfilled, (state, action) => {
        state.getReportSpeakersLoading = false;
        state.speakers = action.payload;
      })
      .addCase(fetchReportSpeakers.rejected, (state, action) => {
        state.getReportSpeakersLoading = false;
        state.getReportSpeakersError = action.payload;
      });
  },
});

export default reportSlice.reducer;
